import { useCallback, useEffect, useRef, useState } from "react";
import "./Tips.css";
import api from "shared/functions/api";

const cardTitles = [
  {
    id: 0,
    title: "Be specific",
    subtitle: "Geography, Period, Scenario, Account or Topic",
  },
  {
    id: 1,
    title: "Provide context",
    subtitle: "Give the model some background information",
  },
  {
    id: 2,
    title: "Ask single questions",
    subtitle: "Give the model some background information",
  },
  {
    id: 3,
    title: "Experiment and iterate",
    subtitle: "Try different approaches",
  },
];

export function Tips() {
  const [cards, setCards] = useState([]);
  const effectRan = useRef(false);
  const getInitialPromptsToTry = useCallback(async () => {
    try {
      const jwt = localStorage.getItem("jwt") || "";
      const prompts = await api.fetchPromptsTotry(jwt, "filter");
      setCards(prompts);
    } catch (error) {
      console.error("Prompt to try error:", error);
    }
  }, []);

  const getCardTitle = (cardId: number) => {
    return cardTitles.find(i => +i.id === +cardId)
  }

  useEffect(() => {
    if (!effectRan.current) {
      getInitialPromptsToTry();
    }
    return () => {
      effectRan.current = true;
    };
  });

  return (
    <>
      <div>
        <h2 className="tip-title">Quick tips for better prompts</h2>
      </div>

      <div className="tip-cards-containers">
        {cards.map((card: any) => {
          return <>
            <div className="tip-card">
              <div className="tip-card-content">
                <h3 className="tip-card-title">{getCardTitle(card.id)?.title}</h3>
                <span className="tip-card-content-span">
                  {getCardTitle(card.id)?.subtitle}
                </span>
              </div>
              <div className="tip-card-content">
                <span className="tip-card-content-prompt">
                  {card.content}
                </span>
              </div>
            </div>
          </>
        })}

        
      </div>
    </>
  );
}
